import MuiTabs, { tabsClasses } from "@mui/material/Tabs";
import { styled } from "@mui/material/styles";

export const TabsContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  "& button": {
    fontSize: `${theme.typography.h3.fontSize}`,
  },
}));

export const Tabs = styled(MuiTabs)(({ indicatorColor, theme }) => ({
  [`& .${tabsClasses.indicator}`]: {
    display: "flex",
    justifyContent: "center",
    height: "3px",
    "& > span": {
      bottom: "6px",
      maxWidth: 100,
      width: "100%",
      backgroundColor: indicatorColor ? "inherit" : "black",
    },
  },
  //need to know how to make first-of-type work to enable this code.
  [`& .${tabsClasses.scrollButtons}`]: {
    transition: "width ease-out .4s",
    "&.Mui-disabled": {
      width: "0px",
    },
  },
}));
